module.exports = __webpack_public_path__ + "static/media/server-storage.3d5efe27.svg";